import { render, staticRenderFns } from "./VoucherCardItem.vue?vue&type=template&id=797ef4f6&scoped=true"
import script from "./VoucherCardItem.vue?vue&type=script&lang=js"
export * from "./VoucherCardItem.vue?vue&type=script&lang=js"
import style0 from "./VoucherCardItem.vue?vue&type=style&index=0&id=797ef4f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ef4f6",
  null
  
)

export default component.exports